import { Star } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { Tooltip } from "@tokenterminal/core/ui/overlays/tooltip/Tooltip"
import { twMerge } from "tailwind-merge"

/**
 * A custom IconButton component for toggling favorites. We compose it this way
 * so we can do some custom icon transitions when transitioning between
 * favorited states.
 */

export const FavoriteIconButton = ({
  isFavorited,
  handleToggleFavorite,
}: {
  isFavorited: boolean
  handleToggleFavorite: () => void
}) => {
  return (
    <Tooltip
      content={isFavorited ? "Remove from favorites" : "Add to favorites"}
    >
      <Button
        className={twMerge("tt-icon-button")}
        onPress={handleToggleFavorite}
        variant="ghost"
        size="small"
      >
        <div className="relative">
          <Star
            className="text-fg-secondary"
            style={{
              opacity: isFavorited ? 0 : 1,
              transition:
                "opacity 0.2s ease-in-out, transform 0.2s ease-in-out",
              transform: isFavorited ? "scale(0.8)" : "scale(1)",
            }}
          />
          <Star
            className="text-fg-secondary"
            weight="fill"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              opacity: isFavorited ? 1 : 0,
              transition:
                "opacity 0.2s ease-in-out, transform 0.2s ease-in-out",
              transform: isFavorited ? "scale(1)" : "scale(0.8)",
            }}
          />
        </div>
      </Button>
    </Tooltip>
  )
}
